<script setup lang="ts">
// L'OUTIL de recherche multi-collections.
//
// Cette page reste 100 % fonctionnelle pour les visiteurs (barre de recherche,
// filtres, résultats live) mais n'est PAS indexée : `useRechercheSeo` la passe
// en `noindex, follow` quand le type vaut « tout ».
//
// POURQUOI : un outil de recherche est dynamique, filtré, à état volatil — il
// ne peut pas être une bonne page d'atterrissage. Les rayons stables et
// paginés (/associations, /cagnottes, /evenements, /adhesions) portent le SEO.
// Même partage des rôles que HelloAsso, qui interdit `/e/recherche` dans son
// robots.txt tout en laissant crawler son annuaire.
definePageMeta({ key: (route) => route.path });
</script>

<template>
  <ListingView type="tout" />
</template>
